import React from 'react'
import {useSelector} from 'react-redux'
import {Permission} from '../../interfaces/user'
import {RootState} from '../../redux/store'
import {hasPermission} from '../utilities'

interface ExampleComponentPermissionProps {
  permission: Permission
  children: React.ReactNode
}

const RoleBaseGuard: React.FC<ExampleComponentPermissionProps> = ({permission, children}) => {
  const currentUser = useSelector((state: RootState) => state.authSlice.user)

  return hasPermission(currentUser, permission) ? <>{children}</> : null
}

export default RoleBaseGuard
